import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map, of, throwError } from 'rxjs';
import { TokenData, User } from '../models/user';
import { Role } from '@core/models/role';
import { environment } from 'environments/environment.development';
import { jwtDecode } from 'jwt-decode';
import { KeycloackService } from './keycloack.service';
import { ApplicationConstants } from '@shared/models/constants';
import { ActivatedRoute } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public currentUserSubject: BehaviorSubject<any> = {} as BehaviorSubject<User>;
  public currentUser: Observable<User> = {} as Observable<User>
  private loggedInSubject = new BehaviorSubject<boolean>(false);
  public loggedIn = this.loggedInSubject.asObservable();
  private authUrl = `${environment.authUrl}/realms/${environment.realm}/protocol/openid-connect/token`;
  private logoutUrl = `${environment.authUrl}/realms/${environment.realm}/protocol/openid-connect/logout?post_logout_redirect_uri=${encodeURIComponent(window.location.origin)}`;

  private refreshToken: string = '';

  private users = [
    {
      id: 1,
      img: 'assets/images/user/admin.jpg',
      username: 'admin@school.org',
      password: 'admin@123',
      firstName: 'Sarah',
      lastName: 'Smith',
      role: Role.Admin,
      token: 'admin-token',
    },
    {
      id: 2,
      img: 'assets/images/user/teacher.jpg',
      username: 'teacher@school.org',
      password: 'teacher@123',
      firstName: 'Ashton',
      lastName: 'Cox',
      role: Role.Teacher,
      token: 'teacher-token',
    },
    {
      id: 3,
      img: 'assets/images/user/student.jpg',
      username: 'student@school.org',
      password: 'student@123',
      firstName: 'Ashton',
      lastName: 'Cox',
      role: Role.Student,
      token: 'student-token',
    },
  ];

  constructor(
    private http: HttpClient,
    private keyCloackService: KeycloackService,
    private route: ActivatedRoute,

  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser') || '{}')
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  // login(username: string, password: string) {

  //   const user = this.users.find((u) => u.username === username && u.password === password);

  //   if (!user) {
  //     return this.error('Username or password is incorrect');
  //   } else {
  //     localStorage.setItem('currentUser', JSON.stringify(user));
  //     this.currentUserSubject.next(user);
  //     return this.ok({
  //       id: user.id,
  //       img: user.img,
  //       username: user.username,
  //       firstName: user.firstName,
  //       lastName: user.lastName,
  //       token: user.token,
  //     });
  //   }
  // }
  // ok(body?: {
  //   id: number;
  //   img: string;
  //   username: string;
  //   firstName: string;
  //   lastName: string;
  //   token: string;
  // }) {
  //   return of(new HttpResponse({ status: 200, body }));
  // }
  // error(message: string) {
  //   return throwError(message);
  // }
  // login(username: string, password: string,remember:boolean=false, otp?: string) {
  //   // const keycloak: KeycloakInstance = Keycloak(keycloakConfig);

  //   const myheader = new HttpHeaders().set(
  //     'Content-Type',
  //     'application/x-www-form-urlencoded'
  //   );
  //   let body = new URLSearchParams();

  //   body.set('username', username);
  //   body.set('password', password);
  //   body.set('grant_type', 'password');
  //   body.set('client_id', environment.clientId);
  //   body.set('client_secret', environment.clientSecret);

  //   if (remember) {

  //     body.set('scope', "openid offline_access");
  //   }

  //   // {
  //   //   username,
  //   //   password,
  //   // }
  //   return this.http
  //     .post<any>(this.authUrl, body.toString(), { headers: myheader })
  //     .pipe(
  //       map((res) => {
  //         var token_data: TokenData = jwtDecode(res.access_token);
  //         var roles = token_data?.realm_access?.roles ?? [];

  //         var user: User = {
  //           firstName: token_data.given_name,
  //           lastName: token_data.family_name,
  //           img: 'https://www.w3schools.com/howto/img_avatar.png',
  //           id: token_data.sub,
  //           password: '',
  //           role: roles,
  //           username: token_data.preferred_username,
  //           name: token_data.name,
  //           token: res.access_token,
  //           email: token_data.email,
  //           refresh_token: res?.refresh_token,
  //           is2FaEnabled:false
  //         };

  //         localStorage.setItem('currentUser', JSON.stringify(user));
  //         this.currentUserSubject.next(user);
  //         this.setLoggedIn(true);
  //         // this.fetchUserCompanies()
  //         return user;
  //       }),
  //     );
  // }
  login(username: string, password: string, remember: boolean = false, otp?: string) {
    const myheader = new HttpHeaders().set(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );
    let body = new URLSearchParams();

    body.set('username', username);
    body.set('password', password);
    body.set('grant_type', 'password');
    body.set('client_id', environment.clientId);
    body.set('client_secret', environment.clientSecret);

    if (otp) {
      body.set('totp', otp); // Add OTP (TOTP) if provided
    }

    if (remember) {
      body.set('scope', 'openid offline_access'); // Request offline_access for refresh token
    }

    return this.http.post<any>(this.authUrl, body.toString(), { headers: myheader }).pipe(
      map((res) => {
        const token_data: TokenData = jwtDecode(res.access_token);
        const roles = token_data?.realm_access?.roles ?? [];

        const user: User = {
          firstName: token_data.given_name,
          lastName: token_data.family_name,
          img: '/assets/images/user/user_img.png',
          id: token_data.sub,
          password: '',
          role: roles,
          username: token_data.preferred_username,
          name: token_data.name,
          token: res.access_token,
          email: token_data.email,
          refresh_token: res?.refresh_token,
          is2FaEnabled: roles.includes('otp_enabled')
        };

        localStorage.setItem('currentUser', JSON.stringify(user));
        this.currentUserSubject.next(user);
        this.setLoggedIn(true);

        return user;
      }),

    );
  }


  redirectToOtpSetup(): void {
    const otpSetupUrl = this.getRedirectAuthUrl();

    // Redirect the user to Keycloak OTP setup page
    window.location.href = otpSetupUrl;
    console.log(otpSetupUrl, "otpSetupUrl");

  }

   getRedirectAuthUrl():string {
    const keycloakBaseUrl = environment.authUrl;
    const realm = environment.realm;
    const clientId = environment.clientId;
    const redirectUri = `${window.location.protocol}//${window.location.host}/sso-callback`;
    // const redirectUri = window.location.origin;
    // Construct Keycloak login URL for OTP setup
    const otpSetupUrl = `${keycloakBaseUrl}/realms/${realm}/protocol/openid-connect/auth` +
      `?client_id=${clientId}` +
      `&redirect_uri=${redirectUri}` +
      `&response_type=code` +
      `&scope=openid`;
    return otpSetupUrl;
  }

  setRefreshToken(refreshToken: string) {
    this.refreshToken = refreshToken;
  }

  getLogin(): Observable<boolean> {
    return this.loggedInSubject;
  }

  public setLoggedIn(value: boolean): void {
    this.loggedInSubject.next(value);
  }

  getRefreshToken(): Observable<any> {
    const body = new URLSearchParams();
    body.set('grant_type', 'refresh_token');
    body.set('client_id', environment.clientId);
    body.set('client_secret', environment.clientSecret);
    body.set('refresh_token', this.refreshToken);

    return this.http.post(this.authUrl, body.toString(), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  logout() {
   var token = this.currentUserValue?.token ?? '';
   const token_data: TokenData = jwtDecode(token);
   var id_token=this.currentUserValue.id_token ?? '';
   console.log(jwtDecode(token), "token");
   
   
    if (localStorage.getItem("currentUser")) {
      
      localStorage.removeItem('currentUser');
    }
    this.currentUserSubject.next(null);
    window.location.href = this.getLogoutUrl +"&id_token_hint="+id_token
    // if (this.currentUserValue.refresh_token && this.currentUserValue.refresh_token != '') {
      
    //   localStorage.removeItem('currentUser');
    //   this.currentUserSubject.next(null);
    //   let logoutUrl =this.logoutUrl;
    //   window.location.href = logoutUrl;
    
    //   // if (idToken) {
    //   //   logoutUrl += `&id_token_hint=${}`;
    //   // }
      
    //   // logoutUrl += `&post_logout_redirect_uri=${encodeURIComponent(this.postLogoutRedirectUri)}`;
  
    //   // Redirect to Keycloak logout
    //   // const myheader = new HttpHeaders({
    //   //   Authorization: 'Bearer ' + this.currentUserValue.token,
    //   //   'Content-Type': 'application/x-www-form-urlencoded',
    //   // });
    //   // let body = new URLSearchParams();

    //   // // body.set("grant_type", "password")
    //   // body.set('client_id', environment.clientId);
    //   // body.set('client_secret', environment.clientSecret);
    //   // body.set('refresh_token', this.currentUserValue.refresh_token ?? '');
    //   // this.http
    //   //   .post<any>(this.logoutUrl, body.toString(), { headers: myheader })
    //   //   .subscribe((res) => {
    //   //     localStorage.removeItem('currentUser');
    //   //     this.currentUserSubject.next(null);
          
    //   //   });
    // } else {
    //   localStorage.removeItem('currentUser');
    //   this.currentUserSubject.next(null);
    // }
    return of({ success: false });
  }

  isReseller() {
    return this.currentUserValue.role.includes(ApplicationConstants.RESELLER_ROLE)
  }

  isAdmin() {
    return this.currentUserValue.role.includes(ApplicationConstants.ADMIN_ROLE)
  }

  isPrinter() {
    return this.currentUserValue.role.includes(ApplicationConstants.PRINTER_ROLE)
  }

  get isLoggedIn(): boolean {
    return localStorage.getItem('currentUser') != null;
  }



  /**
   * Exchange authorization code for an access token.
   */
  //  exchangeCodeForToken(authCode: string): Observable<any> {
  //   const body = new HttpParams()
  //     .set('client_id', environment.clientId)
  //     .set('client_secret', environment.clientSecret)
  //     .set('grant_type', 'authorization_code')
  //     .set('code', authCode)
  //     .set('redirect_uri', window.location.origin);

  //   const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

  //   return this.http.post<any>(this.authUrl, body.toString(), { headers }).pipe(
  //     catchError(error => {
  //       console.error('Token exchange failed:', error);
  //       return throwError(() => new Error('Failed to exchange authorization code for a token.'));
  //     })
  //   );
  // }
  exchangeCodeForToken(code: string) {
    const myheader = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    let body = new URLSearchParams();
    const redirectUri = `${window.location.protocol}//${window.location.host}/sso-callback`;
    // const redirectUri = "http://localhost:4200/sso-callback";
    body.set("grant_type", "authorization_code");
    body.set("client_id", environment.clientId);
    body.set("client_secret", environment.clientSecret);
    body.set("redirect_uri", `${redirectUri}`);
    body.set("code", code);
    body.set("scope", "openid offline_access email profile");
  
    return this.http.post<any>(this.authUrl, body.toString(), { headers: myheader }).pipe(
      map((res) => {
        console.log(res, "res");
        
        return this.HandleToken(res);
      }),
      catchError((error) => {
        console.error("Token exchange failed:", error);
  
        // Redirect to OTP setup if token exchange fails
        // this.redirectToOtpSetup();
  
        return throwError(() => new Error('Failed to exchange authorization code for a token.'));
      })
    );
  }
  
   HandleToken(res: any) {
    const token_data: TokenData = jwtDecode(res.access_token);
    const refresh_token_data: TokenData = jwtDecode(res.access_token);
    const roles = token_data?.realm_access?.roles ?? [];

    const user: User = {
      firstName: token_data.given_name,
      lastName: token_data.family_name,
      img: '/assets/images/user/user_img.png',
      id: token_data.sub,
      password: '',
      role: roles,
      username: token_data.preferred_username,
      name: token_data.name,
      token: res.access_token,
      email: token_data.email,
      refresh_token: res?.refresh_token,
      id_token: res?.id_token,
      is2FaEnabled: roles.includes('otp_enabled')
    };

    localStorage.setItem('currentUser', JSON.stringify(user));
    this.currentUserSubject.next(user);
    this.setLoggedIn(true);
    const refreshTokenExpiry = res.refresh_expires_in; 

    
    const isRememberMe = refreshTokenExpiry > 86400; 
    
    if (isRememberMe) {
      console.log("Remember Me enabled, keeping session persistent.");
      localStorage.setItem("remember_me", "true");
  } else {
      console.log("Remember Me disabled, session will expire on browser close.");
      localStorage.removeItem("remember_me");

      // 🔹 Set session_expiry flag to track that this session should expire when browser is closed
      sessionStorage.setItem("session_expiry", "true");

      
  }
   
    return user;
  }

get getLogoutUrl(): string {
    return this.logoutUrl;
}
get getAuthUrl(): string {
return window.location.protocol + '//' + window.location.host + '/authentication/signin';
}

}